export default defineNuxtRouteMiddleware(async (to) => {
  // Skip auth check for public routes
  const publicRoutes = ['/login', '/register', '/forgot-password']

  // Tighter API exemption - only allow specific auth endpoints
  if (publicRoutes.includes(to.path) ||
      to.path.startsWith('/api/auth/') ||
      to.path === '/api/_auth/session') {
    return
  }

  const auth = useAuth()

  if (!auth) {
    return navigateTo(`/login?redirect=${encodeURIComponent(to.fullPath)}`)
  }

  const { loggedIn, user } = auth

  // Check if user is logged in via nuxt-auth-utils session
  if (!loggedIn.value) {
    return navigateTo(`/login?redirect=${encodeURIComponent(to.fullPath)}`)
  }

  // Role-based redirects for homepage (only ROLE_VALIDATOR goes to /sales)
  if (to.path === '/' && user.value?.roles?.includes('ROLE_VALIDATOR')) {
    return navigateTo('/sales')
  }
})
